




























































import Vue from "vue";
import Component from "vue-class-component";
import NewUserDialog from "./NewUserDialog.vue";
import UserDialog from "./UserDialog.vue";
import UserType from "../types/user";
import userService from "../services/userService";

@Component({
  components: {
    NewUserDialog,
    UserDialog,
  },
})
export default class UserTable extends Vue {
  showUserDialog = false;

  showRemoveDialog = false;

  search = "";

  headers = [
    { text: "Name", value: "name" },
    { text: "Email", value: "email" },
    { text: "Age", value: "age" },
    { text: "Actions", value: "actions", sortable: false, filterable: false },
  ];

  users: UserType[] = [];

  error = "";

  fetchUsers(): void {
    userService.getUsers().then((response) => {
      this.error = "";
      if (!response.error && response.data) this.users = response.data;
      else this.error = response.message;
    });
  }

  mounted() {
    this.fetchUsers();
  }

  selectedUser: UserType | null = null;

  submit(value: UserType) {
    userService.createUser(value).then((response) => {
      this.error = "";
      this.showUserDialog = false;
      this.fetchUsers();
      if (response.error) this.error = response.message;
    });
  }

  update(value: UserType) {
    userService.updateUser(value).then((response) => {
      this.error = "";

      this.showUserDialog = false;
      this.fetchUsers();
      if (response.error) this.error = response.message;
    });
  }

  deleteUser(user: UserType) {
    this.selectedUser = user;
    this.showRemoveDialog = true;
  }

  cancelDelete() {
    this.showRemoveDialog = false;
    this.selectedUser = null;
  }

  confirmDelete() {
    if (this.selectedUser)
      userService.deleteUser(this.selectedUser._id).then((response) => {
        this.error = "";
        this.showRemoveDialog = false;
        this.fetchUsers();
        if (response.error) this.error = response.message;
      });
  }

  openUserDialog({ user }: { user?: UserType }) {
    if (user) {
      this.selectedUser = user;
    } else {
      this.selectedUser = null;
    }

    this.showUserDialog = true;
  }
}
